module.exports = __webpack_public_path__ + "img/sh.746cf520.gif";